var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEykoData(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#EykoData_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.5 0v12M14 .5H1",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.884 11.52h-.961v-.937h-.024c-.418.719-1.033 1.078-1.845 1.078-.598 0-1.067-.158-1.407-.474-.335-.317-.503-.737-.503-1.26 0-1.121.66-1.774 1.98-1.957l1.799-.252c0-1.02-.412-1.53-1.236-1.53-.723 0-1.375.247-1.958.739v-.985C8.32 5.567 9 5.38 9.77 5.38c1.41 0 2.115.746 2.115 2.238v3.902zm-.961-3.035l-1.447.2c-.446.062-.782.173-1.008.334-.227.156-.34.435-.34.837 0 .293.103.534.31.721.211.184.49.275.838.275.477 0 .87-.165 1.178-.498.313-.335.469-.76.469-1.271v-.598z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 3.5h-12v10h12v-10z",
    stroke: "currentColor"
  }))));
}

export default SvgEykoData;